
import { connect } from 'react-redux'
import { compose } from 'redux'
import { listarRelatoriosUser, setJsonGerarOkReportDeveloper } from '../../actions'
import { withRouter } from "react-router-dom";


const mapStateToProps = ({ OkReportReducer }, props) => {
    const { loading, lista } = OkReportReducer.rListaRelatoriosUser;

    let relatorios = [];

    let meta = props.meta;
    if (!meta) {
        meta = {}
    }
    if (props.tipoModelo) {
        relatorios = lista.filter((r) => r.tipoModelo === props.tipoModelo)
    }

    return {
        loading, lista, relatorios, meta
    };
};

export default connect(mapStateToProps, { listarRelatoriosUser, setJsonGerarOkReportDeveloper }, null, { withRef: true })
// export default compose(
//     connect(mapStateToProps, { listarRelatoriosUser, setJsonGerarOkReportDeveloper }, null, { withRef: true }),
//     withRouter,

// );





// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/PainelEmiteRelatorio/PainelEmiteRelatorio.enhancer.js